<template>
  <div class="attributes container">
    <StatisticIcon name="AC" icon="game-icons:bordered-shield" :value="stats.ac" constant unit=" " condensed />
    <StatisticIcon
      v-if="!stats.nohp"
      name="HP"
      icon="game-icons:empty-hourglass"
      :value="hpdice"
      unit=" "
      condensed
      :title="hpdice"
    />
    <StatisticIcon
      v-if="!stats.noinitiative"
      name="Init"
      icon="game-icons:empty-hourglass"
      :value="stats.initiative || 'dex'"
      condensed
    />
    <StatisticIcon
      v-for="speed in speeds"
      :key="speed.name"
      :name="speed.name"
      :icon="speed.icon"
      :value="speed.value || 0"
      constant
      unit="ft"
      :title="speed.label"
      condensed
    />
    <StatisticIcon
      v-if="senses.name !== 'none'"
      :name="senses.name"
      :icon="senses.icon"
      :value="senses.value"
      unit="ft"
      constant
      :title="senses.label"
      condensed
    />
    <StatisticIcon
      name="Percep"
      icon="game-icons:human-ear"
      :value="perception"
      constant
      unit=" "
      condensed
      :title="`Passive Perception ${perception}`"
    />
    <StatisticIcon name="Prof" icon="fa6-regular:star" value="prof" constant condensed />
  </div>
</template>

<script setup lang="ts">
import { type StatblockData, resolveSenses, resolveSpeed, hitDice, skillExpr, totalLevel } from '../statblock/statblock'
import StatisticIcon from '../charactersheet/StatisticIcon.vue'
import { joinDice } from '~/assets/dice/diceEval'

const props = defineProps<{
  stats: StatblockData
}>()

const mods = useMods()

const hitdie = computed(() => props.stats.hitdie || hitDice[props.stats.size])
const hpdice = computed(() => {
  if (props.stats.hp) return props.stats.hp
  const level = totalLevel(props.stats.level)
  const usePlayerHp = props.stats.player ? 'p' : ''
  const hitdice = props.stats.hitdice || `${level}${hitdie.value}`
  const hpdice = `${hitdice}${usePlayerHp}`
  return joinDice(hpdice, level * mods().con, props.stats.bonushp || 0)
})

const speeds = computed(() => resolveSpeed(props.stats.speed))

const senses = computed(() => resolveSenses(props.stats.senses))

const perception = computed(() => skillExpr(props.stats, 'perception', true))
</script>

<style scoped lang="postcss">
.attributes {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-bottom: 0.5em;
}
</style>
